// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q2I7zqvQOPBuCwl6bEhR{fill:var(--theme-link-label-color, #000);height:12px;width:12px}.uN34ORss4F1Pl3iY1oYC{opacity:1}.tOUz06USivDqTmxW9Rn7{opacity:.5}.YDeAoyGiVzZQK2uYnn4c{transform:rotate(180deg)}.zS6dT1AaB_U4PA8IZCfq{align-items:center;background-color:var(--theme-link-color, #fff);border:0;border-radius:50%;box-shadow:1px 0 4px 2px rgba(0,0,0,.3);display:flex;height:24px;justify-content:center;position:absolute;top:40%;transform:translateY(-50%);width:24px}.qqKIN7C4jksVBstZD5wj{left:-15px;right:auto}.IgFDHZa5cGxoM1Q4wMsS{left:auto;right:-15px}.VQWQ5FnzlJ9k8VwEV4WA{cursor:pointer}.Tjaic15eLJGHOl6VFjmH{cursor:not-allowed}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"arrow": `Q2I7zqvQOPBuCwl6bEhR`,
	"arrowIsActive": `uN34ORss4F1Pl3iY1oYC`,
	"arrowIsInactive": `tOUz06USivDqTmxW9Rn7`,
	"arrowPositionRight": `YDeAoyGiVzZQK2uYnn4c`,
	"arrowCircle": `zS6dT1AaB_U4PA8IZCfq`,
	"arrowCircleLeft": `qqKIN7C4jksVBstZD5wj`,
	"arrowCircleRight": `IgFDHZa5cGxoM1Q4wMsS`,
	"arrowCircleIsActive": `VQWQ5FnzlJ9k8VwEV4WA`,
	"arrowCircleIsInactive": `Tjaic15eLJGHOl6VFjmH`
};
export default ___CSS_LOADER_EXPORT___;
